import { render } from "./GreenButton.vue?vue&type=template&id=4f7464c9&scoped=true&ts=true&lang=pug"
import script from "./GreenButton.vue?vue&type=script&lang=ts&setup=true"
export * from "./GreenButton.vue?vue&type=script&lang=ts&setup=true"

import "./GreenButton.vue?vue&type=style&index=0&id=4f7464c9&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4f7464c9"]])

export default __exports__